var map = {
	"./en/ap.png": "CLYJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KSES";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1 ^\.\/.*\/ap\.png$
// module id = KSES
// module chunks = 0